import { spawn } from 'redux-saga/effects';
import { watchGetAll } from './allGames';

export function* gamesSaga() {
  yield spawn(watchGetAll);
}
